import { API_BASE_URL, API_CREATE_CLASS } from '../../consts';
import axios from "axios";
import refreshAccessToken from './refreshAccessToken';


export type ResultDetail = {
    [key: string]: boolean[]; // Keys like "hard-heard", "cat-cut", etc., and their boolean arrays
};

export type classInfo = {
    newClassName: string,
};

export type getCreateClassReponse = {
    status: string,
    message: string
};


async function executeGetCreateClassWithToken(accessToken: string | null, classInfo: classInfo): Promise<getCreateClassReponse> {
    return axios
        .post(
            API_BASE_URL + API_CREATE_CLASS,
            {
                newClassName: classInfo.newClassName,
            },
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            }
        )
        .then(response => {
            if (response.status === 201) {
                return Promise.resolve(response.data);
            }
            throw new Error("Unexpected response status or missing data");
        })
        .catch(error => {
            if (error.response && error.response.status === 400) {
                console.log("Bad Request");
            } else if (error.response && error.response.status === 403) {
                console.log("Missing required role");
            } else {
                console.error('Error during creation:', error);
            }
            return Promise.reject(error);
        });
}


export default async function autoRefreshedExecuteGetCreateClassWithToken(accessToken: string | null, classInfo: classInfo): Promise<getCreateClassReponse> {

    return executeGetCreateClassWithToken(accessToken, classInfo)
        .catch(error => {
            if (error.response.status == 401) {
                return refreshAccessToken().then(refreshedAccessToken => {
                    if (refreshedAccessToken) {
                        console.log("refreshed");
                        return executeGetCreateClassWithToken(accessToken, classInfo);
                    } else {
                        throw error;
                    }
                });
            }
            throw error;
        });
}
